'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _dropzone = require('dropzone');

var _dropzone2 = _interopRequireDefault(_dropzone);

var _reactRedux = require('react-redux');

var _makerActions = require('../../actions/makerActions');

var _form = require('../form');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ImageOptions = function (_Component) {
	_inherits(ImageOptions, _Component);

	function ImageOptions(props) {
		_classCallCheck(this, ImageOptions);

		var _this = _possibleConstructorReturn(this, (ImageOptions.__proto__ || Object.getPrototypeOf(ImageOptions)).call(this, props));

		_this.handleImageUploaded = _this._handleImageUploaded.bind(_this);
		_this.handleUpdateCaption = _this._handleUpdateCaption.bind(_this);
		_this.handleRemoveImage = _this._handleRemoveImage.bind(_this);

		return _this;
	}

	_createClass(ImageOptions, [{
		key: 'componentDidMount',
		value: function componentDidMount() {

			var that = this;

			this.dropzone = new _dropzone2.default(this.dropzoneElement, {
				url: '/ajax/image',
				acceptedFiles: '.jpg,.jpeg,.png,.gif',
				params: { _token: CSRF_TOKEN, model: 'Report' },
				dictDefaultMessage: '<i class="ri-plus-o"></i><br>Drop images here or click to add.'
			});

			this.dropzone.on('success', function (file, data) {
				data.caption = '';
				that.handleImageUploaded(data);
				// file.previewElement.parentNode.removeChild(file.previewElement);
			});

			this.dropzone.on('uploadprogress', function (file, progress, bytesSent) {
				console.log(progress);
			});

			this.dropzone.on('error', function (self, msg) {
				console.log(msg);
			});
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var component = this.props.component;


			return _react2.default.createElement(
				'div',
				{ className: 'image-options' },
				_react2.default.createElement(_form.Input, {
					onChange: this.handleTextChange.bind(this, 'title'),
					placeholder: 'Title',
					value: component.title,
					wrapperClass: 'option-input',
					label: 'Title'
				}),
				_react2.default.createElement(_form.Input, {
					onChange: this.handleTextChange.bind(this, 'description'),
					placeholder: 'Description',
					value: component.description,
					wrapperClass: 'option-input',
					label: 'Description'
				}),
				_react2.default.createElement(
					'div',
					{ className: 'images' },
					component.images.map(function (image, i) {
						return _react2.default.createElement(
							'div',
							{ className: 'image', key: i },
							_react2.default.createElement('div', { className: 'img',
								style: {
									backgroundImage: 'url(' + image.sizes.logo.url + ')'
								} }),
							_react2.default.createElement(
								'div',
								{ className: 'caption' },
								_react2.default.createElement('input', {
									type: 'text',
									value: image.caption,
									onChange: _this2.handleUpdateCaption.bind(null, i),
									placeholder: 'Caption'
								})
							),
							_react2.default.createElement(
								'div',
								{ className: 'ix-remove-image', onClick: _this2.handleRemoveImage.bind(null, i) },
								_react2.default.createElement('i', { className: 'ri-cross' })
							)
						);
					})
				),
				_react2.default.createElement('div', { className: 'dropzone', ref: function ref(e) {
						_this2.dropzoneElement = e;
					} })
			);
		}
	}, {
		key: 'handleTextChange',
		value: function handleTextChange(field, e) {
			var _props = this.props,
			    component = _props.component,
			    selectedComponent = _props.selectedComponent,
			    dispatch = _props.dispatch;

			component[field] = e.target.value;
			dispatch((0, _makerActions.updateComponent)(selectedComponent, component));
		}
	}, {
		key: '_handleImageUploaded',
		value: function _handleImageUploaded(data) {
			var _props2 = this.props,
			    component = _props2.component,
			    selectedComponent = _props2.selectedComponent,
			    dispatch = _props2.dispatch;

			component.images = [].concat(_toConsumableArray(component.images), [data]);
			dispatch((0, _makerActions.updateComponent)(selectedComponent, component));
		}
	}, {
		key: '_handleUpdateCaption',
		value: function _handleUpdateCaption(index, e) {
			var _props3 = this.props,
			    component = _props3.component,
			    selectedComponent = _props3.selectedComponent,
			    dispatch = _props3.dispatch;

			component.images[index].caption = e.target.value;
			dispatch((0, _makerActions.updateComponent)(selectedComponent, component));
		}
	}, {
		key: '_handleRemoveImage',
		value: function _handleRemoveImage(index) {
			var _props4 = this.props,
			    component = _props4.component,
			    selectedComponent = _props4.selectedComponent,
			    dispatch = _props4.dispatch;

			component.images = [].concat(_toConsumableArray(component.images.slice(0, index)), _toConsumableArray(component.images.slice(index + 1)));
			dispatch((0, _makerActions.updateComponent)(selectedComponent, component));
		}
	}]);

	return ImageOptions;
}(_react.Component);

var mapStateToProps = function mapStateToProps(state) {
	return {};
};

ImageOptions = (0, _reactRedux.connect)(mapStateToProps)(ImageOptions);

exports.default = ImageOptions;


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/components/maker/ImageOptions.js
// module id = 577
// module chunks = 0